module.exports = __webpack_public_path__ + "img/404-page-not-found.815596f6.jpg";